import type { RouteObject } from 'react-router-dom'

import { type LeftSide, leftSideActions } from '@appStore/reducers/leftSideMenu'
import store from '@appStore/store'
import accountSvg from 'assets/image/icons/svg/account.svg'
import archiveSvg from 'assets/image/icons/svg/archive.svg'
import spamSvg from 'assets/image/icons/svg/spam.svg'
import unionSvg from 'assets/image/icons/svg/union.svg'

import { Chat } from './Chat/Chat'
import { ChatHeader } from './ChatHeader/ChatHeader'
import { AvailabilityCheck } from './Unavailable/AvailabilityCheck'

const leftSide: LeftSide = {
	bottomList: [
		{
			id: 1,
			image: accountSvg,
			key: 'focused',
			link: '/messaging',
			title: 'Focused'
		},
		{
			id: 2,
			image: unionSvg,
			key: 'other',
			link: '/messaging',
			title: 'Other'
		},
		{
			id: 3,
			image: archiveSvg,
			key: 'archive',
			link: '/messaging',
			title: 'Archived'
		},
		{
			id: 4,
			image: spamSvg,
			key: 'spam',
			link: '/messaging',
			title: 'Spam'
		},
	],
	type: 'messaging'
}

function onLoad() {
	const setSideBar = leftSideActions.setLeftSide(leftSide)
	store.dispatch(setSideBar)
}

export const Route: RouteObject = {
	children: [
		{
			element: [<ChatHeader key='🎩' />, <Chat key='🗨️' />],
			path: 'thread/:conversation'
		}
	],
	Component: AvailabilityCheck,
	loader: onLoad,
	path: '/messaging'
}
